import React from 'react';
import { Row, Col, Input, Button } from 'reactstrap';
import store from 'store';
import Loader from 'react-loader';
import Radio from '../HTMLelements/Radio';

import HttpClient from '../../services/REST/HttpClient';
import { Subscription } from 'rxjs';

import './style.scss';

class HelpForm extends React.Component {
    constructor(props) {
        super(props);
        this.subscriptions = new Subscription();
        this.isOpen = false;

        this.state = { 
            uName: '',
            title: '',
            message: '',
            options: [
                { label: 'I need help using the application', value: 'usability', selected: true },
                { label: 'The application is not working as I expect, there may be a bug', value: 'bug', selected: false },
                { label: 'I have a regulatory content question', value: 'query', selected: false },
                { label: 'I have a suggestion to improve your product', value: 'suggestion', selected: false }
            ],
            error: false,
            requestError: false,
            success: false,
            loaded: true
        };
        this.closeHelpForm = this.closeHelpForm.bind(this);
        this.closeHelpFormKeyup = this.closeHelpFormKeyup.bind(this);
        this.onOptionChange = this.onOptionChange.bind(this);
        this.onTitleChange = this.onTitleChange.bind(this);
        this.onMessageChange = this.onMessageChange.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
    }

    componentDidMount() {
        const session = store.get('CorlyticsSession');
        if (session) this.setState({ uName: session.message.replace('Welcome ', '') });
    }

    componentWillUnmount() {
        this.subscriptions.unsubscribe();
    }

    componentDidUpdate() {
        if (this.isOpen !== this.props.open) {
            this.isOpen = this.props.open;
            if (this.isOpen) this.refs.closeIcon.focus();
        }
    }

    closeHelpForm() {
        this.props.close();
        this.clearForm();

        const btn = document.querySelector('.helpform-button');
        if (btn) btn.focus();
    }

    closeHelpFormKeyup(e) {
        if (e.keyCode === 13) this.closeHelpForm();
    }

    onOptionChange(e) {
        this.setState(state => {
            state.options = state.options.map(item => ({...item, selected: item.value === e }));
            state.error = false;
            state.requestError = false;
            return state;
        });
    }

    onTitleChange(e) {
        const trg = e.target;
        this.setState({ title: trg.value, error: false, requestError: false });
    }

    onMessageChange(e) {
        const trg = e.target;
        this.setState({ message: trg.value, error: false, requestError: false });
    }

    onFormSubmit() {
        this.setState({ error: false, success: false, requestError: false });

        let valid = true;
        let selected = null;
        if (!this.state.title.length || !this.state.message.length) valid = false;
        if (valid) {
            for (let option of this.state.options) {
                if (option.selected) selected = option;
            }
            if (!selected) valid = false;
        }
        if (!valid) return this.setState({ error: true });

        this.setState({ loaded: false });

        const data = {
            support_type: selected.value,
            title: this.state.title,
            details: this.state.message
        };

        this.subscriptions.add(
            HttpClient.post('/help/', data).subscribe(resp => {
                this.setState(state => {
                    state.loaded = true;
                    state.success = true;
                    state.title = '';
                    state.message = '';
                    state.options = state.options.map(item => ({...item, selected: false }));
                    return state;
                }, () => setTimeout(() => {
                    this.closeHelpForm();
                    this.clearForm();
                }, 3000));
            }, error => {
                this.setState({ requestError: true, loaded: true });
            })
        );
    }

    clearForm() {
        this.setState(state => {
            state.title = '';
            state.message = '';
            for (let option of state.options) {
                option.selected = option.value === 'usability';
            }
            state.error = false;
            state.requestError = false;
            state.success = false;
            return state;
        });
    }

    render() {
        return (
            <div className={'help-form-container' + (this.props.open ? ' active' : '')}>
                <div className="help-form-header text-center">
                    {/* <span>Hi {this.state.uName}! Please send us your question</span> */}
                    <span>Support Request</span>
                    <i 
                        className="fa fa-times" 
                        tabIndex="0" 
                        onKeyUp={this.closeHelpFormKeyup} 
                        onClick={this.closeHelpForm}
                        ref="closeIcon"
                    ></i>
                </div>
                <div className="container-fluid">
                    <Row className="mt-3">
                        <Col className="help-form-title">What kind of support do you need?</Col>
                    </Row>
                    <Row className="mt-3">
                        <Col>
                            {
                                this.state.options.map((item, i) => {
                                    return (
                                        <Row key={i}>
                                            <Col>
                                                <Radio 
                                                    label={item.label} 
                                                    value={item.value} 
                                                    id={'custom_radio_opt_' + item.value} 
                                                    name={'custom_radio_opt_' + item.value}
                                                    change={this.onOptionChange}
                                                    isSelected={item.selected}
                                                />
                                            </Col>
                                        </Row>
                                    )
                                })
                            }
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col>
                            <label className="visually-hidden" for="helpFormMessageTitle">Message Title</label>
                            <Input 
                                id="helpFormMessageTitle"
                                type="text" 
                                placeholder="Message Title" 
                                className="_placeholder"
                                value={this.state.title}
                                onChange={this.onTitleChange}
                            />
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <label className="visually-hidden" for="helpFormMessageBody">Message Body</label>
                        <Col>
                            <Input 
                                id="helpFormMessageBody"
                                style={{height: '250px'}} 
                                type="textarea" 
                                placeholder="Message Details" 
                                className="_placeholder"
                                value={this.state.message}
                                onChange={this.onMessageChange}
                            />
                        </Col>
                    </Row>
                    
                    <Row style={{height: '35px'}}>
                        <Col className="mt-2">
                            {this.state.error &&
                                <div className="help-form-error text-center">Both Message Title and Message Details need to be entered.</div>
                            }
                            {this.state.success &&
                                <div className="help-form-success text-center">Thank you, your request has been successfully submitted</div>
                            }
                            {this.state.requestError &&
                                <div className="help-form-error text-center">Error occurred while sending request</div>
                            }
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={6}>
                            <div 
                                type="button" 
                                tabIndex="0" 
                                className="btn btn-secondary-new" 
                                onClick={this.closeHelpForm}
                                onKeyUp={this.closeHelpFormKeyup}
                                style={{cursor: 'pointer'}}
                            >Cancel</div> 
                        </Col>
                        <Col xs={6} className="text-right">
                            <Loader loaded={this.state.loaded} color='#BD2E2A' scale={0.5} top="12px" left="70%">
                                <button className="btn btn-primary-new" disabled={this.state.success} onClick={this.onFormSubmit}>Submit</button>
                            </Loader>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
    
}

export default HelpForm;


// WEBPACK FOOTER //
// ./src/components/HelpForm/HelpForm.js